/** Formate une date ISO (AAAA-MM-JJ) en JJ/MM/AAAA */
export function formatDateFR(dateStr) {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('T')[0].split('-');
  if (!y || !m || !d) return dateStr;
  return `${d}/${m}/${y}`;
}

const capitalizeFr = (value) => {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1);
};

/** Normalise une heure (HH:MM ou HH:MM:SS) en HH:MM */
export function formatTimeFR(timeStr) {
  if (!timeStr) return '';
  const [hours, minutes] = String(timeStr).split(':');
  if (!hours || minutes === undefined) return timeStr;
  return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
}

/**
 * Date + heure en français : "Samedi 11 Juillet 2026 à 10:00"
 * @param {string} dateStr - AAAA-MM-JJ
 * @param {string} [timeStr] - HH:MM ou HH:MM:SS
 */
export function formatDateTimeFR(dateStr, timeStr) {
  if (!dateStr) return '';

  const [y, m, d] = dateStr.split('T')[0].split('-').map(Number);
  if (!y || !m || !d) {
    return timeStr ? `${dateStr} à ${formatTimeFR(timeStr)}` : dateStr;
  }

  const date = new Date(y, m - 1, d);
  const parts = new Intl.DateTimeFormat('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).formatToParts(date);

  const get = (type) => parts.find((p) => p.type === type)?.value ?? '';
  let formatted = `${capitalizeFr(get('weekday'))} ${get('day')} ${capitalizeFr(get('month'))} ${get('year')}`;

  if (timeStr) {
    formatted += ` à ${formatTimeFR(timeStr)}`;
  }

  return formatted;
}
